import { render, staticRenderFns } from "./reportForm.vue?vue&type=template&id=64765582&scoped=true&"
import script from "./reportForm.vue?vue&type=script&lang=js&"
export * from "./reportForm.vue?vue&type=script&lang=js&"
import style0 from "./reportForm.vue?vue&type=style&index=0&id=64765582&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64765582",
  null
  
)

export default component.exports